import * as React from 'react';

import { hexToRGBA } from 'common/js/colors';
import cssStyle from './index.scss';

interface Props {
  id?: string;
  children: JSX.Element;
  onClick: (e: React.MouseEvent) => any;
  onTouchStart?: (e: React.TouchEvent) => any;
  backgroundColor?: string;
  backgroundOpacity?: number;
  labelColor?: string;
  labelOpacity?: number;
  fontSize?: string;
  iconSize?: number;
  style?: React.CSSProperties;
  useContainerStyle?: boolean;
  controlBlockStyle?: React.CSSProperties;
}

export default function Control({
  id,
  children,
  onClick = () => {},
  onTouchStart = () => {},
  backgroundColor = '#28323c',
  backgroundOpacity = 0.5,
  labelColor = '#FFFFFF',
  labelOpacity = 1,
  fontSize = '16px',
  iconSize = 16,
  style = {},
  useContainerStyle = true,
  controlBlockStyle = {}
}: Props) {
  let blocStyle: React.CSSProperties;
  if (controlBlockStyle) {
    blocStyle = controlBlockStyle;
  } else {
    if (useContainerStyle) {
      blocStyle = {
        background: hexToRGBA(backgroundColor, backgroundOpacity),
        color: hexToRGBA(labelColor, labelOpacity),
        fill: hexToRGBA(labelColor, labelOpacity),
        fontSize,
        ...style
      };
    } else {
      blocStyle = {
        width: iconSize,
        height: iconSize
      };
    }
  }

  return (
    <div
      id={id}
      onTouchStart={onTouchStart}
      onClick={onClick}
      style={blocStyle}
      className={useContainerStyle ? cssStyle.container : ''}
    >
      {children}
    </div>
  );
}
